import { ENTRY_SOURCE } from '~/store/slices/settingsSlice';

import type { BUILDINGS } from '~/Actions/ActionSupply';

export const getEntrySourceFromUrl = (fallback: ENTRY_SOURCE = ENTRY_SOURCE.PROFILE) => {
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source') as ENTRY_SOURCE | null;

  return source || fallback;
};

export const getBuildingIdFromUrl = (fallback?: BUILDINGS) => {
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('buildingId') as BUILDINGS | null;

  return source || fallback;
};
